<nb-card class="detail-card" [nbSpinner]="loading()" data-cy="contractor-repair-task-detail">
  <nb-card-header>
    Reparaturauftrag
    @if (repairTask(); as task) {
      – {{ task.title }}
    }
  </nb-card-header>
  <nb-card-body>
    @if (repairTask(); as task) {
      <dl class="facts">
        <dt>Status</dt>
        <dd><wr-repair-task-status-text data-cy="contractor-repair-task-status" [status]="task.status"></wr-repair-task-status-text></dd>

        @if (task.building) {
          <dt>Gebäude</dt>
          <dd>{{ task.building.name }} ({{ task.building.internalNumber }})</dd>
        }
        @if (task.buildingSection) {
          <dt>Adresse</dt>
          <dd>{{ task.buildingSection.sectionText }}</dd>
        }
        @if (task.inspectionEntry) {
          <dt>Prüfpunkt</dt>
          <dd>{{ task.inspectionEntry.checkpointName }}</dd>
          @if (task.inspectionEntry.action) {
            <dt>Maßnahme</dt>
            <dd>{{ task.inspectionEntry.action.name }}</dd>
          }
          @if (task.inspectionEntry.note) {
            <dt>Feststellung</dt>
            <dd class="multiline">{{ task.inspectionEntry.note }}</dd>
          }
        }
        @if (task.buildingEquipment) {
          <dt>TGA</dt>
          <dd>{{ task.buildingEquipment.equipmentName }}</dd>
        }
        @if (task.deadline) {
          <dt>Frist</dt>
          <dd>{{ task.deadline | date: 'dd.MM.yyyy' }}</dd>
        }
        @if (task.creatorTenant) {
          <dt>Auftraggeber</dt>
          <dd>{{ task.creatorTenant.name }}@if (task.creatorName) { ({{ task.creatorName }})}</dd>
        }
        @if (task.description) {
          <dt>Beschreibung</dt>
          <dd class="multiline">{{ task.description }}</dd>
        }
      </dl>

      @if (task.inspectionEntryAttachments.length > 0) {
        <h6>Fotos der Prüfpunktzeile</h6>
        <wr-attachments-carousel [attachments]="task.inspectionEntryAttachments"></wr-attachments-carousel>
      }

      @if (task.status === 'FINISHED') {
        <h6>Abschluss</h6>
        <dl class="facts">
          @if (task.finishedAt) {
            <dt>Abgeschlossen am</dt>
            <dd>{{ task.finishedAt | date: 'dd.MM.yyyy HH:mm' }}</dd>
          }
          @if (task.closedByName) {
            <dt>Durch</dt>
            <dd>{{ task.closedByName }}</dd>
          }
          <dt>Kommentar</dt>
          <dd class="multiline" data-cy="contractor-repair-task-completion-comment">{{ task.completionComment }}</dd>
        </dl>
        @if (task.completionAttachments.length > 0) {
          <wr-attachments-carousel [attachments]="task.completionAttachments"></wr-attachments-carousel>
        }
      }

      @if (task.status === 'DECLINED') {
        <h6>Storniert</h6>
        <dl class="facts">
          @if (task.declinedAt) {
            <dt>Storniert am</dt>
            <dd>{{ task.declinedAt | date: 'dd.MM.yyyy HH:mm' }}</dd>
          }
          <dt>Grund</dt>
          <dd class="multiline" data-cy="contractor-repair-task-decline-comment">{{ task.declineComment }}</dd>
        </dl>
      }
    }
  </nb-card-body>
  <nb-card-footer class="footer">
    <button nbButton outline status="basic" (click)="dismiss()">Schließen</button>
    @if (canClose()) {
      <div class="actions">
        <button nbButton outline status="danger" data-cy="contractor-repair-task-decline" (click)="close('decline')">
          Stornieren
        </button>
        <button nbButton status="success" data-cy="contractor-repair-task-finish" (click)="close('finish')">
          Abschließen
        </button>
      </div>
    }
  </nb-card-footer>
</nb-card>
